const pathMap = {
  '/sucesso/': { en: '/success/', es: '/exito/' },
  '/politica-de-privacidade/': {
    en: '/privacy-policy/',
    es: '/politica-de-privacidad/',
  },
  '/termos-de-uso/': { en: '/terms-of-use/', es: '/terminos-de-uso/' },
  '/jeito-dimas/': { en: '/dimas-way/', es: '/camino-dimas/' },
  '/acesse-condominio/': {
    en: '/access-condominium/',
    es: '/acceso-condominio/',
  },
  '/contato/': { en: '/contact/', es: '/contacto/' },
  '/contato/faq/': { en: '/contact/faq/', es: '/contacto/faq/' },
  '/contato/trabalhe-conosco/': {
    en: '/contact/work-with-us/',
    es: '/contacto/trabaja-con-nosotros/',
  },
  '/empreendimentos/': { en: '/enterprises/', es: '/empresas/' },
  '/empreendimentos/entregues/': {
    en: '/enterprises/handed/',
    es: '/empresas/entrego/',
  },
  '/empreendimentos/lancamentos/': {
    en: '/enterprises/releases/',
    es: '/empresas/lanzamientos/',
  },
  '/campanha-de-indicacao/': {
    en: '/referral-campaign/',
    es: '/campana-de-referencia/',
  },
  '/sucesso-campanha/': {
    en: '/campaign-success/',
    es: '/exito-campana/',
  },
}

exports.translatePath = (pathname, withPrefix = false) => {
  if (
    process.env.GATSBY_LANGUAGE !== 'en' &&
    process.env.GATSBY_LANGUAGE !== 'es'
  )
    return pathname

  const prefix = !withPrefix
    ? ''
    : process.env.GATSBY_LANGUAGE === 'en'
    ? '/en'
    : '/es'

  const entry = pathMap[pathname]
  const ret = entry ? entry[process.env.GATSBY_LANGUAGE] : pathname

  return prefix + ret
}

// Retorna as 3 variantes de um caminho canônico (PT), independente do
// GATSBY_LANGUAGE do build atual — usado para gerar as tags hreflang.
exports.getAlternatePaths = (pathname) => {
  const entry = pathMap[pathname]
  return {
    pt: pathname,
    en: entry ? entry.en : pathname,
    es: entry ? entry.es : pathname,
  }
}
